import Dialog from "./abstract/AbstractDialog";
import VirtualList from "../../components/common/VirtualList.component.js";

export default class DialogAddTerm extends Dialog {
  constructor(template, callback = null) {
    super(template, callback);

    this.select = null;
    this.vSelect = null;
  }

  init(fields, path) {
    super.init();
    this.initVSelect(fields);
    jQuery(".js-parent-path", this.dialog).text(path);
  }

  // init vSelect
  initVSelect(fields) {
    this.select = this.dialog.querySelector(".js-virtual-select");
    this.vSelect = new VirtualList(this.select, {
      options: fields,
      entryHeight: 30,
      valueKey: "_path",
      labelKey: "Label",
      isSelect: true,
      hasSearch: true,
      numberOfRows: 8,
    });
    this.vSelect.init();
  }

  onConfirm(e) {
    e.preventDefault();

    if (!this.vSelect.value) {
      !this.select.classList.contains("has-error") && this.select.classList.add("has-error");
    } else {
      this.select.classList.remove("has-error");

      this.hide();
      this.callback?.call(null, this.vSelect.value);
    }
  }

  onDismiss(e) {
    e.preventDefault();

    this.hide();
    this.callback?.call(null, null);
  }
}
